/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddPrintersRequestPrintersInnerAnyOf7 } from './AddPrintersRequestPrintersInnerAnyOf7';
import {
    AddPrintersRequestPrintersInnerAnyOf7FromJSON,
    AddPrintersRequestPrintersInnerAnyOf7FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf7ToJSON,
    AddPrintersRequestPrintersInnerAnyOf7ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf7';
import type { AddPrintersRequestPrintersInnerAnyOf3 } from './AddPrintersRequestPrintersInnerAnyOf3';
import {
    AddPrintersRequestPrintersInnerAnyOf3FromJSON,
    AddPrintersRequestPrintersInnerAnyOf3FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf3ToJSON,
    AddPrintersRequestPrintersInnerAnyOf3ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf3';
import type { AddPrintersRequestPrintersInnerAnyOf4 } from './AddPrintersRequestPrintersInnerAnyOf4';
import {
    AddPrintersRequestPrintersInnerAnyOf4FromJSON,
    AddPrintersRequestPrintersInnerAnyOf4FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf4ToJSON,
    AddPrintersRequestPrintersInnerAnyOf4ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf4';
import type { AddPrintersRequestPrintersInnerAnyOf5 } from './AddPrintersRequestPrintersInnerAnyOf5';
import {
    AddPrintersRequestPrintersInnerAnyOf5FromJSON,
    AddPrintersRequestPrintersInnerAnyOf5FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf5ToJSON,
    AddPrintersRequestPrintersInnerAnyOf5ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf5';
import type { AddPrintersRequestPrintersInnerAnyOf6 } from './AddPrintersRequestPrintersInnerAnyOf6';
import {
    AddPrintersRequestPrintersInnerAnyOf6FromJSON,
    AddPrintersRequestPrintersInnerAnyOf6FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf6ToJSON,
    AddPrintersRequestPrintersInnerAnyOf6ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf6';
import type { AddPrintersRequestPrintersInnerAnyOf } from './AddPrintersRequestPrintersInnerAnyOf';
import {
    AddPrintersRequestPrintersInnerAnyOfFromJSON,
    AddPrintersRequestPrintersInnerAnyOfFromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOfToJSON,
    AddPrintersRequestPrintersInnerAnyOfToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf';
import type { AddPrintersRequestPrintersInnerAnyOf1 } from './AddPrintersRequestPrintersInnerAnyOf1';
import {
    AddPrintersRequestPrintersInnerAnyOf1FromJSON,
    AddPrintersRequestPrintersInnerAnyOf1FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf1ToJSON,
    AddPrintersRequestPrintersInnerAnyOf1ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf1';
import type { AddPrintersRequestPrintersInnerAnyOf2 } from './AddPrintersRequestPrintersInnerAnyOf2';
import {
    AddPrintersRequestPrintersInnerAnyOf2FromJSON,
    AddPrintersRequestPrintersInnerAnyOf2FromJSONTyped,
    AddPrintersRequestPrintersInnerAnyOf2ToJSON,
    AddPrintersRequestPrintersInnerAnyOf2ToJSONTyped,
} from './AddPrintersRequestPrintersInnerAnyOf2';

/**
 * 
 * @export
 * @interface AddPrintersRequestPrintersInner
 */
export interface AddPrintersRequestPrintersInner {
    /**
     * 
     * @type {string}
     * @memberof AddPrintersRequestPrintersInner
     */
    type: AddPrintersRequestPrintersInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddPrintersRequestPrintersInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddPrintersRequestPrintersInner
     */
    ip: string;
}


/**
 * @export
 */
export const AddPrintersRequestPrintersInnerTypeEnum = {
    Zpl: 'ZPL',
    Usb: 'Usb',
    Kds: 'KDS',
    UsbAndroid: 'UsbAndroid',
    EscPos: 'EscPos',
    EscPosMatrix: 'EscPosMatrix',
    StarPrnt: 'StarPRNT',
    StarGraphic: 'StarGraphic'
} as const;
export type AddPrintersRequestPrintersInnerTypeEnum = typeof AddPrintersRequestPrintersInnerTypeEnum[keyof typeof AddPrintersRequestPrintersInnerTypeEnum];


/**
 * Check if a given object implements the AddPrintersRequestPrintersInner interface.
 */
export function instanceOfAddPrintersRequestPrintersInner(value: object): value is AddPrintersRequestPrintersInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ip' in value) || value['ip'] === undefined) return false;
    return true;
}

export function AddPrintersRequestPrintersInnerFromJSON(json: any): AddPrintersRequestPrintersInner {
    return AddPrintersRequestPrintersInnerFromJSONTyped(json, false);
}

export function AddPrintersRequestPrintersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddPrintersRequestPrintersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'ip': json['ip'],
    };
}

export function AddPrintersRequestPrintersInnerToJSON(json: any): AddPrintersRequestPrintersInner {
    return AddPrintersRequestPrintersInnerToJSONTyped(json, false);
}

export function AddPrintersRequestPrintersInnerToJSONTyped(value?: AddPrintersRequestPrintersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'ip': value['ip'],
    };
}

